import { cssClass } from '@/shared/utils'
import { ConnectionCardSkeleton } from 'containers/profile-network/components/ProfileCardSkeleton'
import { ProfileCardBase } from 'containers/profile-network/components/profiles-cards/ProfileCardBase'
import { recommendationCardButtons } from 'containers/profile-network/styles/connectionCard.css'
import { ANONYMOUS_VIEWER_ID } from 'containers/profile-views/types/profileViews'
import { AcceptDeclineButtons } from 'containers/profile/components/buttons/AcceptDeclineButtons'
import { RequestConnectionButton } from 'containers/profile/components/buttons/RequestConnectionButton'
import { ViewProfileButton } from 'containers/profile/components/buttons/ViewProfileButton'
import {
  useProfileById,
  useProfileRelationType,
} from 'containers/profile/hooks/useProfile'
import { ProfileRelationType } from 'containers/profile/types/profile'
import { useMemo } from 'react'

export interface ProfileViewerContainerProps {
  id: string
  showAnonymousViewer?: boolean
}

export const ProfileViewerContainer = ({
  id,
  showAnonymousViewer = true,
}: ProfileViewerContainerProps) => {
  const { profile, isLoading } = useProfileById(id)
  const relation = useProfileRelationType(profile)

  const profileInfo = useMemo(() => {
    if (id === ANONYMOUS_VIEWER_ID || !profile) {
      return {
        avatar: '/assets/avatar-anonymous-viewer.svg',
        firstName: 'Anonymous',
        lastName: 'Viewer',
        username: '',
      }
    }

    return profile
  }, [id, profile])

  if (isLoading) {
    return <ConnectionCardSkeleton />
  }

  if (!showAnonymousViewer && (id === ANONYMOUS_VIEWER_ID || !profile)) {
    return null
  }

  return (
    <div className="full-w">
      <ProfileCardBase profile={profileInfo} isInRecommendationsColumn>
        {id !== ANONYMOUS_VIEWER_ID && (
          <div
            className={cssClass([
              recommendationCardButtons,
              'ml-auto mr-0 flex items-end justify-flex-end',
            ])}
          >
            <>
              <RequestConnectionButton
                profile={profile}
                maxWidthClass="full-w"
                containerClassName="full-w"
              />
              {relation === ProfileRelationType.CONNECTION_RECEIVED && (
                <AcceptDeclineButtons profile={profile} />
              )}

              {relation === ProfileRelationType.CONNECTION && (
                <ViewProfileButton profile={profile} maxWidthClass="full-w" />
              )}
            </>
          </div>
        )}
      </ProfileCardBase>
    </div>
  )
}
